<template>
  <tr>
    <td>{{ taskCategory.title }}</td>
    <td class="is-number"
        :class="{'is-number--calculated': isDateIntervalChanged }"
        :content='schoolTooltipContent'
        v-tippy="{
          animateFill: false,
          animation : 'shift-away',
        onShow: () => isDateIntervalChanged
      }">
      <span class="icon-clock" v-if="isDateIntervalChanged"></span>
      {{ sumOfHours }}
    </td>
    <td class="is-number" v-if="isShowScheduled">{{ sumOfActual }}</td>
    <td class="is-number" v-if="isShowScheduled">
      {{ sumOfDiff }}
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    taskCategory: {
      default: () => []
    },
    isDateIntervalChanged: {
      default: false
    },
    isShowScheduled: {
      default: true
    }
  },
  computed: {
    tasks () {
      return this.taskCategory.tasks
    },
    sumOfHours () {
      let tasksHours = [0]
      if (this.tasks.length > 0) {
        tasksHours = this.tasks.map(task => {
          return task.hours ? parseFloat(task.hours) : 0
        })
      }
      let sum = tasksHours.reduce((acc, item) => acc + item)
      return this.toFixedIfNecessary(sum, 2)
    },
    sumOfActual () {
      let tasksActual = [0]
      if (this.tasks.length > 0) {
        tasksActual = this.tasks.map(task => {
          let actual = task.actual ? task.actual : 0
          return parseFloat(actual)
        })
      }
      let sum = tasksActual.reduce((acc, item) => acc + item)
      return this.toFixedIfNecessary(sum, 2)
    },
    sumOfDiff () {
      let tasksNumbers = [0]
      if (this.tasks.length > 0) {
        tasksNumbers = this.tasks.map(task => {
          return task.diff ? parseFloat(task.diff) : 0
        })
      }
      let sum = tasksNumbers.reduce((acc, item) => acc + item)
      return this.toFixedIfNecessary(sum, 2)
    }
  },
  methods: {
    toFixedIfNecessary (value, dp) {
      // https://stackoverflow.com/questions/32229667/have-max-2-decimal-places/32229831
      return +parseFloat(value).toFixed(dp)
    }
  }
}
</script>

<style scoped>
.is-number {
  text-align: right;
}

td {
  padding: 0.25rem;
}


.d-table tbody td:nth-child(3),
.d-table tbody td:nth-child(4),
.d-table tbody td:nth-child(5) {
  width: 10%;
}
</style>



// WEBPACK FOOTER //
// UserTasksOverviewOwnPoolsPool.vue?8025efa4